// stores/batchStore.ts
import { create } from 'zustand';
import apiClient from '../apiSetup/axiosInterceptor';

interface Batch {
  batch_id: string;
  institute_id: string;
  branch_id: string;
  course_id: string;
  batch_name: string;
  batch_time: string; // e.g., "10:00 - 12:00"
  start_month: string;
  start_year: number;
  end_month: string;
  end_year: number;
  is_active: boolean;
  created_at: string; // e.g., "2026-01-14 17:16:55"
}

interface Pagination {
  total: number;
  page: number;
  limit: number;
  pages: number;
}

interface ApiResponse {
  success: boolean;
  data: Batch[];
  pagination: Pagination;
}

interface BatchState {
  batches: Batch[] | null;
  pagination: Pagination | null;
  loading: boolean;
  error: string | null;
  fetchBatches: () => Promise<void>;
  clearError: () => void;
}

export const useBatchStore = create<BatchState>((set) => ({
  batches: null,
  pagination: null,
  loading: false,
  error: null,
  clearError: () => set({ error: null }),
  fetchBatches: async () => {
    set({ loading: true, error: null });
    try {
      const response = await apiClient.get<ApiResponse>('/v1/batches');
      set({
        batches: response.data.data,
        pagination: response.data.pagination,
        loading: false,
      });
    } catch (err: any) {
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'Failed to load batches';
      set({ error: message, loading: false });
    }
  },
}));